import { Checkbox } from '@audio-network/componentlibrary'
import { useTranslation } from 'next-i18next'
import { useFormContext } from 'react-hook-form'

import { DownloadOption } from '../../DownloadOptionsModal.types'
import { UNLABELLED_MIX_OPTION_KEY } from '../DownloadOptions.constants'
import downloadOptionsStyles from '../DownloadOptions.module.css'
import { getOptionName } from '../DownloadOptions.utils'
import { MixOptionGroupProps } from './MixOptionGroup.types'

const CUTDOWN_LENGTHS = ['15', '20', '30', '60']

const getMixOptionLabel = (
	option: DownloadOption,
	translate: (key: string, options?: { length: string }) => string
): string => {
	if (CUTDOWN_LENGTHS.includes(option.label)) {
		return translate('mix-type-in-seconds', { length: option.label })
	}

	if (option.label === UNLABELLED_MIX_OPTION_KEY) {
		return translate('other')
	}

	return option.label
}

const MixOptionGroup = ({
	allSelected,
	modalId,
	onSelectAllClick,
	options,
	selectAllButtonId,
	title,
}: MixOptionGroupProps): JSX.Element => {
	const { register } = useFormContext()
	const { t } = useTranslation('download')

	return (
		<fieldset className={downloadOptionsStyles.mixGroup}>
			<legend className={downloadOptionsStyles.srOnly}>{title}</legend>
			<div className={downloadOptionsStyles.mixGroupLegend}>
				<span aria-hidden="true">{title}</span>
				<button
					className={downloadOptionsStyles.selectAllButton}
					id={selectAllButtonId}
					onClick={onSelectAllClick}
					type="button"
				>
					{t(allSelected ? 'deselect-all' : 'select-all')}
				</button>
			</div>
			{options.map((option) => {
				const optionId = `${modalId}-${getOptionName(option)}`
				const optionName = getOptionName(option)
				const label = getMixOptionLabel(option, t)

				return (
					<Checkbox
						id={optionId}
						key={optionId}
						label={
							<span className={downloadOptionsStyles.label}>
								<span className={downloadOptionsStyles.labelDescription}>
									{label}
								</span>{' '}
								<span className={downloadOptionsStyles.meta}>
									{option.count}
								</span>
							</span>
						}
						{...register(optionName)}
					/>
				)
			})}
		</fieldset>
	)
}

export default MixOptionGroup
